export default __webpack_public_path__ + "static/media/PrivateEvents2.775fbbfe.jpg";